const recipesList = [{
        name: 'Soupe du dimanche',
        description: 'La soupe du dimanche avec mémé !',
        ingredient1: 'Patate',
        ingredient2: 'Courgette',
        ingredient3: 'Tomate',
        img1: './images/Patate.png',
        img2: './images/Courgette.png',
        img3: './images/Tomate.png',
        id: 1,
    },
    {
        name: 'L\' amourette',
        description: 'Avec l\' amourette rendez n\'importe qui amoureux de vous !',
        ingredient1: 'Aile',
        ingredient2: 'Dent',
        ingredient3: 'Fleur-1',
        img1: './images/Aile.png',
        img2: './images/Dent.png',
        img3: './images/Fleur-1.png',
        id: 2,

    }, {
        name: 'Carnivore',
        description: 'Miam, Miam ! Moi mangez viande ! ',
        ingredient1: 'Viande-1',
        ingredient2: 'Viande-2',
        ingredient3: 'Dragon',
        img1: './images/Viande-1.png',
        img2: './images/Viande-2.png',
        img3: './images/Dragon.png',
        id: 3,

    }, {
        name: 'Fruity',
        description: '5 fruits et légumes par jour ! Bon là c\'est que des fruits... ',
        ingredient1: 'Banane',
        ingredient2: 'Ananas',
        ingredient3: 'Tomate',
        img1: './images/Banane.png',
        img2: './images/Ananas.png',
        img3: './images/Tomate.png',
        id: 4,

    },
    {
        name: 'Potion',
        description: 'Si on mélange toutes ces potions, peut-être que quelques choses va se passer ? ',
        ingredient1: 'Potion-1',
        ingredient2: 'Potion-2',
        ingredient3: 'Potion-3',
        img1: './images/Potion-1.png',
        img2: './images/Potion-2.png',
        img3: './images/Potion-3.png',
        id: 5,

    },
    {
        name: 'Escargot volant',
        description: "Escargot volant, je vole... je vole ! ",
        ingredient1: 'Escargot',
        ingredient2: 'Aile',
        ingredient3: 'Potion-2',
        img1: "./images/Escargot.png",
        img2: "./images/Aile.png",
        img3: "./images/Potion-2.png",
        id: 6,

    },


    {
        name: 'Gâteau au Monstre',
        description: "C'est tout de suite moins effrayant quand on l'a dans l'assiette!",
        ingredient1: 'Dragon',
        ingredient2: 'Dent',
        ingredient3: 'Aile',
        img1: "./images/Dragon.png",
        img2: "./images/Dent.png",
        img3: "./images/Aile.png",
        id: 7,

    },

    {
        name: 'Le Sanglant Smoothie',
        description: "Dracula ?",
        ingredient1: 'Glace',
        ingredient2: "Viande-2",
        ingredient3: 'Poisson',
        img1: "./images/Glace.png",
        img2: "./images/Viande-2.png",
        img3: "./images/Poisson.png",
        id: 8,

    },


    {
        name: 'A l\'école des sorciers',
        description: "Tu es un sorcier Harry !",
        ingredient1: 'Livre',
        ingredient2: 'Potion-2',
        ingredient3: 'Dragon',
        img1: "./images/Livre.png",
        img2: "./images/Potion-2.png",
        img3: "./images/Dragon.png",
        id: 9,

    },
    {
        name: 'Lembas',
        description: "Petit mais consistant !!",
        ingredient1: 'Fleur-2',
        ingredient2: 'Courgette',
        ingredient3: 'Poivron',
        img1: './images/Fleur-2.png',
        img2: './images/Courgette.png',
        img3: './images/Poivron.png',
        id: 10,

    },
    {
        name: 'Le vegan',
        description: "Par amour du goût",
        ingredient1: 'Fleur-2',
        ingredient2: 'Poivron',
        ingredient3: 'Tomate',
        img1: './images/Fleur-2.png',
        img2: './images/Poivron.png',
        img3: './images/Tomate.png',
        id: 11,

    },
];

export default recipesList;